import { Controller } from "web-ui/controller"

// Connects to data-controller="table-group"
export default class extends Controller {
  static targets = ["table"]

  static events = {
    "click tr.section-heading": "toggle"
  }

  toggle(event, heading) {
    // Do not toggle when inside of an actions cell - Aaron, Sun Aug 23 2026
    if (event.target.closest(".actions-cell")) {
      return
    }

    const section = heading.closest("table")

    this.setCollapsed(section, !section.hasAttribute("collapsed"))
  }

  collapseAll() {
    this.tableTargets.forEach((section) => this.setCollapsed(section, true))
  }

  expandAll() {
    this.tableTargets.forEach((section) => this.setCollapsed(section, false))
  }

  setCollapsed(section, collapsed) {
    section.toggleAttribute("collapsed", collapsed)

    const toggle = section.querySelector(".disclosure-toggle")
    toggle.setAttribute("aria-expanded", String(!collapsed))
  }
}
